import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/**
 * External dependencies
 */

/**
 * Internal dependencies
 */
import { FlexBlock } from '../../flex';
export const SelectWrapper = /*#__PURE__*/_styled(FlexBlock, process.env.NODE_ENV === "production" ? {
  target: "e10bzpgi1"
} : {
  target: "e10bzpgi1",
  label: "SelectWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1gvx10y",
  styles: "flex-grow:5"
} : {
  name: "1gvx10y",
  styles: "flex-grow:5",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImN1c3RvbS1ncmFkaWVudC1waWNrZXItc3R5bGVzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFTZ0QiLCJmaWxlIjoiY3VzdG9tLWdyYWRpZW50LXBpY2tlci1zdHlsZXMudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBFeHRlcm5hbCBkZXBlbmRlbmNpZXNcbiAqL1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuLyoqXG4gKiBJbnRlcm5hbCBkZXBlbmRlbmNpZXNcbiAqL1xuaW1wb3J0IHsgRmxleEJsb2NrIH0gZnJvbSAnLi4vLi4vZmxleCc7XG5cbmV4cG9ydCBjb25zdCBTZWxlY3RXcmFwcGVyID0gc3R5bGVkKCBGbGV4QmxvY2sgKWBcblx0ZmxleC1ncm93OiA1O1xuYDtcblxuZXhwb3J0IGNvbnN0IEFjY2Vzc29yeVdyYXBwZXIgPSBzdHlsZWQoIEZsZXhCbG9jayApYFxuXHRmbGV4LWdyb3c6IDU7XG5gO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
export const AccessoryWrapper = /*#__PURE__*/_styled(FlexBlock, process.env.NODE_ENV === "production" ? {
  target: "e10bzpgi0"
} : {
  target: "e10bzpgi0",
  label: "AccessoryWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1gvx10y",
  styles: "flex-grow:5"
} : {
  name: "1gvx10y",
  styles: "flex-grow:5",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImN1c3RvbS1ncmFkaWVudC1waWNrZXItc3R5bGVzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFhbUQiLCJmaWxlIjoiY3VzdG9tLWdyYWRpZW50LXBpY2tlci1zdHlsZXMudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBFeHRlcm5hbCBkZXBlbmRlbmNpZXNcbiAqL1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuLyoqXG4gKiBJbnRlcm5hbCBkZXBlbmRlbmNpZXNcbiAqL1xuaW1wb3J0IHsgRmxleEJsb2NrIH0gZnJvbSAnLi4vLi4vZmxleCc7XG5cbmV4cG9ydCBjb25zdCBTZWxlY3RXcmFwcGVyID0gc3R5bGVkKCBGbGV4QmxvY2sgKWBcblx0ZmxleC1ncm93OiA1O1xuYDtcblxuZXhwb3J0IGNvbnN0IEFjY2Vzc29yeVdyYXBwZXIgPSBzdHlsZWQoIEZsZXhCbG9jayApYFxuXHRmbGV4LWdyb3c6IDU7XG5gO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});